<template>
  <el-dialog
    :title="signupForm?'Register with us':'Login'"
    :visible.sync="dialogFormVisible"
    :before-close="handleClose"
    :width="isMobile?'100%':'30%'"
    :top="isMobile?'15%':'15vh'"
  >
    <el-dialog width="30%" :visible.sync="innerVisible" append-to-body>
      <span style="font-weight:500">
        Thank You For Registering with us .Confirmation email has been sent your email.Please click the verification link to verify
        your registered email address
      </span>
    </el-dialog>
    <span v-if="message">
      <el-alert :title="message" :type="message_type"></el-alert>
    </span>
    <span v-if="resendConfirmationMessage">
      <el-alert type="warning">
        <slot name="title">
          If you haven't received confirmation linke,Please
          <el-button type="text" @click="sendConfirmationLink">Click here</el-button>to resend it
        </slot>
      </el-alert>
    </span>
    <el-form ref="form">
      <el-form-item label="Name" v-if="signupForm">
        <el-input
          v-validate="{required:true}"
          v-model="user.name"
          autocomplete="off"
          placeholder="Name"
          name="first_name"
        ></el-input>
        <span v-show="errors.has('first_name')" class="red">{{ errors.first('first_name') }}</span>
        <!-- <el-col :span="11">
                                                         
                                                        </el-col>
                                                        <el-col :span="2">
                                                            <div class="grid-content"></div>
                                                        </el-col>
                                                        <el-col :span="11">
                                                            <el-input v-model="user.name.last" autocomplete="off" placeholder="Last Name"></el-input>
        </el-col>-->
      </el-form-item>

      <el-form-item label="Email">
        <el-input v-model="user.email" v-validate="{required:true}" autocomplete="off" name="email"></el-input>
        <span v-show="errors.has('email')" class="red">{{ errors.first('email') }}</span>
      </el-form-item>

      <el-form-item label="Password">
        <el-input
          v-model="user.password"
          autocomplete="off"
          type="password"
          @keyup.enter.native="authenticate()"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="signupForm">
        <a href="#" @click="signupForm=false">Already User?</a>
        <el-button type="success" style="margin-left:20px" @click="register">Register</el-button>
      </el-form-item>
      <el-form-item v-else :label-width="'0px'">
        <el-row>
          <el-col :span="12">
            <a href="#" @click="forgotForm=!forgotForm" style="margin-right:10px">Forgot Password?</a>
            <a href="#" @click="signupForm=true">Register?</a>
          </el-col>

          <el-col :span="10">
            <el-button type="success" style="float:right" @click="authenticate">Login Now</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <div style="text-align:center;display:none">
      <a href="/auth/facebook">
        <el-button round type="primary">
          <i class="fa fa-facebook"></i>
        </el-button>
      </a>
      <a href="/auth/google">
        <el-button round type="danger">
          <i class="fa fa-google"></i>
        </el-button>
      </a>
    </div>
    <div v-if="forgotForm">
      <hr />
      <label style="font-weight:700;text-align:center">Reset Password</label>
      <br />
      <el-input
        v-model="email"
        v-validate="{required:true}"
        autocomplete="off"
        style="width:60%"
        placeholder="Enter your email"
        name="email"
      ></el-input>
      <el-button type="success" style="margin-left:20px" @click="forgotPassword">Reset</el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from "@/api";
export default {
  props: ["dialogFormVisible", "signupForm", "isMobile"],
  data() {
    return {
      user: {
        name: ""
      },
      message: null,
      message_type: "success",
      email: "",
      forgotForm: false,
      innerVisible: false,
      resendConfirmationMessage: false
    };
  },
  methods: {
    async sendConfirmationLink() {
      console.log('sendconfirmation')
      try {
        await api.post("/sendconfirmationlink", this.user);
        this.message =
          "Confirmation Link has been sent your email address, Please confirm account";
        this.message_type = "success";
      } catch (e) {}
    },
    handleClose() {
      this.$emit("close");
    },
    reload() {
      window.location.reload();
    },
    async authenticate() {
      try {
        await api.login(this.user);
        window.location.reload();
      } catch (e) {
        this.showErrorMessage(`${e.data}`);
        this.resendConfirmationMessage = true;
      }
    },
    showErrorMessage(message) {
      if (!message) {
        message = "Something Went wrong,Please try again";
      }
      this.message_type = "error";
      this.message = message;
    },
    async register() {
      try {
        await api.register(this.user);
        console.log("trycach");
        this.message =
          "Confirmation Link has been sent your email address, Please confirm account";
        this.message_type = "success";
        this.innerVisible = true;
      } catch (e) {
        console.log("error", e);
        this.showErrorMessage(e.data);
      }

      this.user = {};

      // window.location.reload()
    },
    async forgotPassword() {
      // delete this.note._id;
      await api.forgotPassword({ email: this.email });
      this.user = {
        name: {}
      };
      this.message = "password reset link has been sent to your email.";
    }
  }
};
</script>

<style>
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

/* .el-dialog {
    width:500px
} */
.red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/SignupForm.vue